import { View, Text, StyleSheet, TouchableOpacity } from "react-native";
import React, { useState, useEffect, useRef } from "react";
import { useDrag, useDrop } from "react-dnd";
import Colors from "../../../Resources/Color";
import Feather from "@expo/vector-icons/Feather";
import AddCalendarBlockView from "../../Block/AddCalendarBlockView";
import { Calendar } from "../../../Resources/Constants";
import {
  Ionicons,
  MaterialCommunityIcons,
  MaterialIcons,
} from "@expo/vector-icons";
import { formatDayMonth } from "../../utils/dateUtils";
import { useDevice } from "../../_layout";

const CalendarBlockRowView = ({
  seg,
  blockColorMap,
  onBlockPress,
  isNoDateBlock = false,
}) => {
  const { isMobile } = useDevice();
  const [isHovered, setIsHovered] = useState(false);
  const [isEditHovered, setIsEditHovered] = useState(false);
  const [showingAddCalendarBlock, setShowingAddCalendarBlock] = useState();

  // --- DRAG AND DROP FOR BLOCK SEGMENTS ---
  const ITEM_TYPE_BLOCK = "BLOCK_SEGMENT";
  const [{ isDragging: isBlockDragging }, dragRef, dragPreview] = useDrag({
    type: ITEM_TYPE_BLOCK,
    item: () => ({
      block: seg.block,
      span: seg.block.totalWeeks,
      key: seg.key,
    }),
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
    end: () => {
      if (seg.block.client) {
        seg.block.client.setProperty("blockHoverStart", null);
        seg.block.client.setProperty("blockHoverSpan", 0);
        seg.block.client.setProperty("blockHoverId", null);
        seg.block.client.setProperty(
          "showingMoveBlockWithWorkoutsWarning",
          false
        );
      }
    },
  });

  useEffect(() => {
    if (isBlockDragging) {
      // this runs once, at the moment the drag starts
      console.log("Block drag started:", seg.block);
      if (seg.block.client && !seg.block.workouts?.some((w) => w.date)) {
        seg.block.client.setProperty("blockHoverId", seg.block.id);
        seg.block.client.setProperty("blockHoverSpan", seg.block.totalWeeks);
      } else if (seg.block.client) {
        seg.block.client.setProperty(
          "showingMoveBlockWithWorkoutsWarning",
          true
        );
      }
    }
  }, [isBlockDragging]);

  if (seg.block) {
    return (
      <TouchableOpacity
        key={seg.key}
        ref={dragRef}
        style={[
          {
            opacity: isBlockDragging ? 0.5 : isHovered ? 0.8 : 1,
            width: seg.span * Calendar.DAY_WIDTH,
            backgroundColor: isNoDateBlock
              ? "rgba(63, 123, 141, 0.20)"
              : blockColorMap[seg.block.id] || "transparent",
            borderWidth: isNoDateBlock ? 1 : 0,
            borderColor: Colors.borderColor,
            borderRadius: 10,
            paddingHorizontal: seg.span > 1 ? 16 : 6,
            paddingVertical: 6,
            height: 34,
            position: "relative",
            flexDirection: "row",
            maxWidth: "100%",
          },
        ]}
        onPress={() => onBlockPress(seg)}
        onMouseEnter={() => !isMobile && setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        disabled={showingAddCalendarBlock}
      >
        <View
          style={{
            flex: 1,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Text
            numberOfLines={1}
            style={{
              fontSize: 12,
              color: Colors.blackColor,
              fontWeight: isHovered ? "500" : "normal",
            }}
          >
            {seg.block.name}
          </Text>
          {/* <Text
            numberOfLines={1}
            style={{ fontSize: 12, color: Colors.blackColor }}
          >
            {formatDayMonth(seg.block.initialDate)}
          </Text>
          <Text
            numberOfLines={1}
            style={{ fontSize: 12, color: Colors.blackColor }}
          >
            {seg.block.effectiveTotalWeeks}
          </Text>
          <Text
            numberOfLines={1}
            style={{ fontSize: 12, color: Colors.blackColor }}
          >
            {formatDayMonth(seg.block.endDate(seg.block.effectiveTotalWeeks))}
          </Text> */}
        </View>
        {(isHovered || isMobile) && (
          <View
            style={{
              position: "absolute",
              right: 0,
              top: 0,
              bottom: 0,
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <TouchableOpacity
              onPress={() => {
                setShowingAddCalendarBlock(true);
              }}
              style={{
                paddingVertical: 2,
                backgroundColor: "rgba(255,255,255,0.45)",
                borderRadius: 8,
                marginRight: 4,
                paddingVertical: 2,
              }}
              onMouseEnter={() => !isMobile && setIsEditHovered(true)}
              onMouseLeave={() => setIsEditHovered(false)}
            >
              <Feather
                name="edit-3"
                size={14}
                color={Colors.bubbleColor}
                style={{
                  opacity: isEditHovered ? 0.6 : 1,
                  paddingRight: 4,
                  paddingLeft: 4,
                  paddingVertical: 1,
                }}
              />
            </TouchableOpacity>
          </View>
        )}
        {seg.span > 1 && (
          <View
            style={{
              position: "absolute",
              left: 0,
              top: 0,
              bottom: 0,
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <MaterialIcons
              name="drag-indicator"
              size={14}
              color={"rgba(0,0,0,0.6)"}
              style={{
                opacity: 1,
                paddingLeft: 2,
              }}
            />
          </View>
        )}

        {showingAddCalendarBlock && (
          <AddCalendarBlockView
            isVisible={showingAddCalendarBlock}
            onClose={() => {
              setShowingAddCalendarBlock(false);
              setIsEditHovered(false);
              setIsHovered(false);
            }}
            client={seg.block.client}
            block={seg.block}
          />
        )}
      </TouchableOpacity>
    );
  }
  return (
    <View key={seg.key} style={{ width: seg.span * Calendar.DAY_WIDTH }} />
  );
};

const styles = StyleSheet.create({});

export default CalendarBlockRowView;
